import { Grid, useMediaQuery } from "@mui/material";
import { Characteristics, specificationItems } from "../../../constants/home";
import {
  SpecificationContainer,
  SpecificationIconContainer,
  SpecificationLogo,
  SpecificationText,
  teachnologyExpertiselabelStyle,
} from "../../../styles/home";
import CustomHeadingWrapper from "../../shared/CustomHeadingWrapper";
import theme from "../../../styles/theme";

export default function CompanySpecification() {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <SpecificationContainer container>
        <Grid
          item
          xs={12}
          data-aos="fade-down"
          data-aos-duration="2000"
          sx={{
            paddingBottom: isMobile ? "10px" : "30px",
          }}
        >
          <CustomHeadingWrapper
            label={Characteristics}
            style={teachnologyExpertiselabelStyle}
          />
        </Grid>
        {specificationItems?.map((item, index) => {
          return (
            <Grid item xs={12} key={index} sm={3} md={3}>
              <SpecificationIconContainer>
                <SpecificationLogo>{item?.icon}</SpecificationLogo>
                <SpecificationText>{item?.label}</SpecificationText>
              </SpecificationIconContainer>
            </Grid>
          );
        })}
      </SpecificationContainer>
    </>
  );
}
